import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners, comics } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = banners.length;

  const goTo = useCallback((index: number) => {
    setCurrent((index + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => goTo(current + 1), 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const banner = banners[current];
  const comic = comics.find((c) => c.id === banner.comicId);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {banners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === current ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={b.bgImage}
            alt={b.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className={`absolute inset-0 bg-gradient-to-b ${banner.gradient}`}></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="max-w-xl">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-background-50/20 text-background-50 rounded-full mb-4 backdrop-blur-sm">
              本周推荐
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3 leading-tight">
              {banner.title}
            </h2>
            <p className="text-sm md:text-base text-background-200 mb-6">
              {banner.subtitle}
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/comic/${banner.comicId}`}
                className="px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即阅读
              </Link>
              {comic && (
                <span className="text-sm text-background-200 flex items-center gap-1">
                  <i className="ri-star-fill text-amber-400"></i>
                  {comic.rating}分
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current ? 'w-6 bg-background-50' : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
          />
        ))}
      </div>
    </section>
  );
}